"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalTemplates = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment-timezone");
var core_1 = require("@athena-portal/core");
var react_router_dom_1 = require("react-router-dom");
var services_1 = require("@falcon/services");
var MotorClaim_1 = require("./model/MotorClaim");
var RentersClaim_1 = require("./model/RentersClaim");
var SupportPortalTemplates = /** @class */ (function () {
    function SupportPortalTemplates() {
        var _this = this;
        this.renderFooter = function (className) { return ((0, jsx_runtime_1.jsxs)("footer", { className: "falcon-footer ".concat(className), children: [(0, jsx_runtime_1.jsx)("div", { className: "falcon-footer-divider-bottom" }), (0, jsx_runtime_1.jsxs)("div", { className: "trademark-container", children: ["\u00A9 Allianz ", moment().format("YYYY")] })] })); };
        this.renderSpinner = function () { return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center", children: (0, jsx_runtime_1.jsx)("div", { className: "spinner-border text-primary", role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: "Loading..." }) }) })); };
        this.convertDate = function (inputDate, format) {
            var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
            if (valueAsMoment.isValid()) {
                return (valueAsMoment.format(format));
            }
            return null;
        };
        this.isTodayBetweenDates = function (startDate, endDate) {
            return moment().isBetween(startDate, endDate);
        };
        this.userHasRole = function (roles) {
            var user = _this.applicationGuard.getUser();
            if (user === null || !user || !user.roles) {
                return false;
            }
            return roles.some(function (role) { return user.roles.indexOf(role) > -1; });
        };
        this.renderHeader = function () {
            var clickLogout = function () {
                var redirectUrl = window.location.origin;
                _this.applicationGuard.logout({ redirectUri: redirectUrl });
            };
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "journey-header", children: (0, jsx_runtime_1.jsxs)("div", { className: "journey-header-background", children: [(0, jsx_runtime_1.jsx)("img", { className: "flow-logo", src: "/img/Allianz-logo.png", alt: "Allianz logo" }), (0, jsx_runtime_1.jsx)("div", { className: "spacer" }), (0, jsx_runtime_1.jsxs)("div", { className: "menu", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", children: "Search customer" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/interactionSearch", children: "Search interaction" }), _this.userHasRole(["Administrator"]) &&
                                        (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/calculateInteraction", children: "Calculate interaction" })] }), (0, jsx_runtime_1.jsx)("img", { className: "sign-out", src: "/img/power-off-white.png", onClick: clickLogout, alt: "Sign out" })] }) }) }));
        };
        this.renderErrorPage = function () {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [_this.renderHeader(), (0, jsx_runtime_1.jsx)("div", { className: "row error-message", children: (0, jsx_runtime_1.jsx)("div", { className: "col-12 alert alert-danger", children: "Access denied! You do not have a sufficient role to access this page." }) })] }));
        };
    }
    SupportPortalTemplates.convertFromCamelCaseAndCapitalize = function (value) {
        return this.capitalize(value.replace(/([a-z])([A-Z])/g, '$1 $2'));
    };
    SupportPortalTemplates.capitalize = function (value) {
        value = value.toLowerCase();
        return value.charAt(0).toUpperCase() + value.slice(1);
    };
    SupportPortalTemplates.getProductByClaim = function (claim) {
        if (claim.claimTypeId <= MotorClaim_1.default.claimCount) {
            return services_1.ProductsEnum.MOTOR;
        }
        else if (claim.claimTypeId <= MotorClaim_1.default.claimCount + RentersClaim_1.default.claimCount) {
            return services_1.ProductsEnum.RENTERS;
        }
        else {
            return services_1.ProductsEnum.HOME;
        }
        return "";
    };
    SupportPortalTemplates.getProductByClaimProduct = function (claim) {
        if (claim.product === services_1.ProductNameEnum.MOTOR) {
            return services_1.ProductsEnum.MOTOR;
        }
        else if (claim.product === services_1.ProductNameEnum.WOLF_MOTOR) {
            return services_1.ProductsEnum.WOLF_MOTOR;
        }
        else if (claim.product === services_1.ProductNameEnum.RENTERS) {
            return services_1.ProductsEnum.RENTERS;
        }
        return this.getProductByClaim(claim);
    };
    SupportPortalTemplates.convertOperationName = function (name) {
        var namesMap = new Map([
            ["INSERT", "Add"],
            ["UPDATE", "Amend"],
            ["DELETE", "Cancel"]
        ]);
        return namesMap.get(name);
    };
    SupportPortalTemplates.convertDateToUkTimeZoneDate = function (date) {
        return moment(date).tz("Europe/London").format("DD/MM/YYYY HH:mm");
    };
    SupportPortalTemplates.convertDateToUkTimeZoneDateWithoutTime = function (date) {
        return moment(date).tz("Europe/London").format("DD/MM/YYYY");
    };
    SupportPortalTemplates.convertNumberToPounds = function (amount) {
        return "\u00A3".concat(amount.toLocaleString("en-GB", { maximumFractionDigits: 2, minimumFractionDigits: 2 }));
    };
    SupportPortalTemplates.prototype.renderBackLink = function (buttonName, isTop, link) {
        if (link) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom"), children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: link, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back-link", children: buttonName }) }) }));
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom"), children: (0, jsx_runtime_1.jsx)("a", { onClick: this.goBack, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back-link", children: buttonName }) }) }));
    };
    SupportPortalTemplates.prototype.goBack = function (event) {
        event.target.href = window.history.back();
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], SupportPortalTemplates.prototype, "applicationGuard", void 0);
    return SupportPortalTemplates;
}());
exports.SupportPortalTemplates = SupportPortalTemplates;
//# sourceMappingURL=SupportPortalTemplates.js.map